module.exports = __webpack_public_path__ + "img/synchronize-arrow-clock.b57b8982.svg";